module.exports = __webpack_public_path__ + "img/nala.0d3cffa9.jpg";